export default {
  'profile.about': 'About',
  'profile.services': 'Services',
  'profile.gallery': 'Gallery',
  'profile.reviews': 'Reviews',
  'profile.contact': 'Contact',
  'profile.rates': 'Rates',
  'profile.languages': 'Languages',
  'profile.attributes': 'Attributes',
  'profile.availability': 'Availability',
  'profile.send_message': 'Send Message',
  'profile.save': 'Save',
  'profile.saved': 'Saved',
  'profile.subscribe': 'Subscribe',
  'profile.premium_content': 'Premium Content',
  'profile.tour_dates': 'Tour Dates',
  'profile.more_about_me': 'More About Me',
  'profile.physical_attributes': 'Physical Attributes',
  'profile.personal_info': 'Personal Info',
  'profile.subscription_required': 'Subscription Required',
  'profile.upgrade_subscription': 'Upgrade Subscription',
  'profile.rates_only_visible': 'Rates are only visible to subscribers',
  'profile.services_available': 'Available Services',
  'profile.reviews_only_visible': 'Reviews are only visible to Regular and VIP members',
  'profile.subscription_unlock': 'Subscribe to unlock exclusive content',
  'profile.view_profile': 'View Profile',
  'profile.message': 'Message',
  'profile.verified': 'Verified',
  'profile.online': 'Online',
  'profile.touring': 'Touring',
  'profile.favorite': 'Add to Favorites',
  'profile.unfavorite': 'Remove from Favorites',
  'profile.tabs.about': 'About',
  'profile.tabs.services': 'Services',
  'profile.tabs.rates': 'Rates',
  'profile.tabs.contact': 'Contact',
  'profile.various_durations': 'Various Durations',
  'profile.no_services': 'No services listed',
  'profile.no_rates': 'No rates listed',
  'profile.back': 'Back',
  'profile.last_online': 'Last Online',
  'profile.registration_date': 'Registration Date',
  'profile.total_views': 'Total Views',
  'profile.personal_information': 'Personal Information',
  'profile.sexual_details': 'Sexual Details',
  'profile.available_services': 'Available Services',
  'profile.working_hours': 'Working Hours',
  'profile.about_me': 'About Me',
  'profile.call': 'Call',
  'profile.booking': 'Booking',
  'profile.contact_availability': 'Contact & Availability',
  'profile.years': 'years',
  'profile.no_phone_number': 'No phone number',
  'profile.contact_through_message': 'Please contact via message',
  'profile.added_to_favorites': 'Added to favorites',
  'profile.removed_from_favorites': 'Removed from favorites',
  'profile.profile_added_to_favorites': '{{name}} has been added to your favorites',
  'profile.profile_removed_from_favorites': '{{name}} has been removed from your favorites',
  'profile.generating_image': 'Generating profile image...',
  'profile.select_date': 'Select a date',
  'profile.select_time': 'Select a time',
  'profile.confirm_booking': 'Confirm Booking',
  'profile.booking_confirmed': 'Booking Confirmed',
  'profile.booking_error': 'Booking Error',
  'profile.select_date_time': 'Please select a date and time',
  'profile.booking_description': 'Book your appointment with this escort',
  'profile.booking_with': 'Booking with',
  'profile.booking_for': 'for',
  'profile.booking_at': 'at',
  'profile.no_availability': 'No availability in the next 24 hours',
  'profile.check_availability': 'Check Availability',
  'profile.public_view': 'Profile',
  'profile.subscriber_view': 'Private Access',
  'profile.private_media': 'Private Media',
  'profile.private_secrets': 'Private Secrets',
  'profile.premium_services': 'Premium Services',
  'profile.unlock_private_content': 'Unlock Private Content',
  'profile.private_content_description': 'Subscribe to access exclusive photos, videos, and special services.',
  'profile.view_private_content': 'View Private Content',
  'profile.subscribe_now': 'Subscribe Now',
  'profile.private_content_locked': 'Private Content Locked',
  'profile.private_content_subscription_needed': 'Subscribe to unlock this escort\'s exclusive content and services',
  'profile.view_all_services': 'View All Services',
  'profile.teaser_upgrade_message': 'You have Teaser access. Upgrade to Regular to view all content',
  'profile.upgrade_now': 'Upgrade Now',
  'profile.time': 'Duration',
  'profile.incall': 'Incall',
  'profile.outcall': 'Outcall',
  'profile.included': 'Included',
  'profile.extra': 'Extra',
  'profile.show_less': 'Show Less',
  'profile.services_description': 'Services included in standard rates or available for an extra fee.',
  'profile.premium_services_description': 'Premium digital services that can be purchased separately without booking an appointment.',
  'messages.starting_conversation': 'Starting conversation',
  'messages.please_wait': 'Please wait while we set up your chat',
  'messages.conversation_created': 'Conversation created',
  'messages.send_first_message': 'You can now send your first message',
  'messages.error_creating': 'Error creating conversation',
  'messages.try_again': 'Please try again later',
  'profile.default_bio': 'Elegant and sophisticated companion with a passion for art and fine dining.',
  'profile.premium_access': 'Premium Access',
  'profile.gender': 'Gender',
  'profile.age': 'Age',
  'profile.nationality': 'Nationality',
  'profile.ethnicity': 'Ethnicity',
  'profile.eye_color': 'Eye Color',
  'profile.hair_color': 'Hair Color',
  'profile.height': 'Height',
  'profile.unit_cm': 'cm',
  'profile.weight': 'Weight',
  'profile.unit_kg': 'kg',
  'profile.measurements': 'Measurements',
  'profile.cup_size': 'Cup Size',
  'profile.intimate_area': 'Intimate Area',
  'profile.smoking': 'Smoking',
  'profile.drinking': 'Drinking',
  'profile.sexual_information': 'Sexual Information',
  'profile.orientation': 'Orientation',
  'profile.interested_in': 'Interested In',
  'profile.preferences': 'Preferences',
  'profile.value_couples': 'Couples',
  'profile.value_singles': 'Singles',
  'profile.experience': 'Experience',
  'profile.value_intermediate': 'Intermediate',
  'profile.kinks': 'Kinks',
  'profile.value_roleplay_lightbdsm': 'Role play, Light BDSM',
  'profile.limits': 'Limits',
  'profile.value_extreme_illegal': 'Extreme pain, Illegal activities',
  'profile.premium_prompt': 'Subscribe to discover her little secrets',
  'profile.contact_information': 'Contact Information',
  'profile.phone': 'Phone',
  'profile.alternative_phone': 'Alternative Phone',
  'profile.contact_via': 'Contact Via',
  'profile.available': 'Available',
  'profile.hours': 'Hours',
  'profile.registered_date_prefix': 'Registered on',
  'profile.today': 'Today',
  'profile.whatsapp': 'WhatsApp',
  'profile.value_available': 'Available',
  'profile.city': 'City',
  'profile.contact_instructions': 'Please indicate via SMS your age, origin, and desired duration.',
  'profile.call_button': 'Call',
  'profile.day_monday': 'Monday',
  'profile.day_tuesday': 'Tuesday',
  'profile.day_wednesday': 'Wednesday',
  'profile.day_thursday': 'Thursday',
  'profile.day_friday': 'Friday',
  'profile.day_saturday': 'Saturday',
  'profile.day_sunday': 'Sunday',
  
  // Adding missing keys
  'years': 'years',
  'last_online': 'Last Online',
  'default_bio': 'Elegant and sophisticated companion with a passion for art and fine dining.',
  'booking': 'Booking',
  'contact_availability': 'Contact & Availability',
  'send_message': 'Send Message',
  'working_hours': 'Working Hours',
  'service': 'Service',
  'status': 'Status',
  'no_premium_services': 'No premium services available',
  'profile.private_access': 'Private Access',
  
  // Keys from logs
  'profile.rates_incall': 'Incall',
  'profile.rates_outcall': 'Outcall',
  'profile.rates_special': 'Special',
  'profile.rates_note': 'Prices may vary. Contact for details.',
  'profile.no_slots_available': 'No slots available',
  'profile.select_rate': 'Select a rate',

  // Rate durations from logs
  'profile.rate_30min': '30 min',
  'profile.rate_1hour': '1 hour',
  'profile.rate_2hours': '2 hours',
  'profile.rate_overnight': 'Overnight',
  'profile.rate_weekend': 'Weekend',

  // Rate category selection
  'profile.select_category': 'Meeting Type',
};
